enum DesignSystemExclusiveTypes {
  HEADER = "header",
  BUTTON = "button",
  NAV = "nav",
  PLACEHOLDER = "placeholder",
  IMAGENOTFOUND = "imagenotfound",
}

export default DesignSystemExclusiveTypes;
